import React, { useEffect } from 'react';

export default function Toast({ message, type = 'success', onClose, duration = 3000 }) {
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [message, duration, onClose]);

  if (!message) return null;

  const isError = type === 'error';

  return (
    <div className="fixed top-5 right-5 z-[200] animate-[slideIn_0.2s_ease-out]">
      <div className={`flex items-center gap-3 px-4 py-3 rounded-xl shadow-lg border max-w-sm ${
        isError ? 'bg-red-50 border-red-200 text-red-700' : 'bg-green-50 border-green-200 text-green-700'
      }`}>
        <span className="text-lg">{isError ? '\u26A0' : '\u2713'}</span>
        <p className="text-sm font-medium flex-1">{message}</p>
        <button onClick={onClose} className="text-current opacity-50 hover:opacity-100">&#10005;</button>
      </div>
    </div>
  );
}
